import { createComponent } from '@uifabric/foundation';
import { CardItemStyles as styles, CardItemTokens as tokens } from './CardItem.styles';
import { CardItemView } from './CardItem.view';
export var CardItem = createComponent(CardItemView, {
    displayName: 'CardItem',
    styles: styles,
    tokens: tokens
});
export default CardItem;
//# sourceMappingURL=CardItem.js.map